import { useMemo } from "react";

import { useGeometrySelection } from "./useGeometrySelection";

export const useGeometrySelectionBuffer = (): string | undefined => {
  const [
    {
      settings: { bufferRadius, bufferMultiplier },
      isBuffer,
    },
  ] = useGeometrySelection();

  return useMemo((): string | undefined => {
    if (!isBuffer || !bufferRadius) {
      return undefined;
    }

    return Number((+bufferRadius || 0) * +bufferMultiplier).toFixed(2);
  }, [isBuffer, bufferRadius, bufferMultiplier]);
};
